import { useTranslation } from "@vixi/localization";
import { RouteOptionsById, RouterIds } from "@vixi/router";
import {
  Button,
  ButtonLink,
  ButtonLinkProps,
  Divider,
  FormDescription,
  FormHeading,
} from "@vixi/ui";

// Icons
import ChevronRightCircle from "@assets/icons/chevron-right-circle.svg?react";

// Constants
export const routeId = "/_app/settings/subscription" satisfies RouterIds;

export const SubscriptionSettingsPageOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};

function RouteComponent() {
  // useGoBack(null); used in the parent route
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center">
      <div>
        <div className="flex justify-center items-center">
          <FormHeading heading="Settings.Subscription.Title">
            <FormDescription className="mt-2.75">{t("Settings.Subscription.Subtitle")}</FormDescription>
          </FormHeading>

        </div>
       
        <div className="max-w-157.5">
          {/* Plan Card */}
          <div className="bg-paper mx-0 my-8 flex flex-col items-center rounded ps-0 pe-0 pt-3.5 pb-6">
            <h5 className="font-semibold">{t("Premium.YourCurrentPlan")}</h5>
            <Divider className="mt-4 mb-6" />
            <h2 className="fs-44 mb-0 font-bold">{t("Premium.Plans.Free")}</h2>
          </div>

          <ButtonLink
            to={"/premium/plans"}
            variant="contained"
            color="premium"
            size="content"
            className="mx-auto flex w-58.25 max-w-full min-w-max justify-start px-4 py-1 text-center"
          >
            <div className="mx-auto">
              {t("Action.UpgradeTo")} {t("Premium.Plans.Pro")}
            </div>
          </ButtonLink>
        </div>

        <Divider className="my-9 w-3/4" />

        <div className="max-w-157.5">
          <div className="bg-paper mt-8 flex items-center justify-between px-8 py-6">
            <p className="fs-16 font-medium">
              {t("Settings.Subscription.ManageSubscriptionInStripe") ||
                "Manage subscription, billing, and receipt in Stripe"}
            </p>
            <Button variant="outlined" size="small">
              {t("Action.Manage")}
            </Button>
          </div>

          <Button className="mx-auto mt-5.5 block px-4 py-1">{t("Action.CancelSubscription")}</Button>
        </div>
      </div>
    </div>
 
  );
}
